<template>
  <div class="container-btn-adicionar-filtro">
    <button @click="toogleSelectAddFiltro" class="btn btn-primary btn-adicionar-filtro">
      <SvgIcon iconName="filter-solid" :size=15 class="fill-white" />
      {{ $i18n('interface.novo_filtro.add_filter') }}
    </button>
    <SelectAdicionarCampos
      v-if="addFilterActive"
      :filtrosSelecionados="filtrosSelecionados"
      @adicionarFiltro="adicionarFiltro"
      :filtros="filtros"
      @close="toogleSelectAddFiltro"
      :campos="campos"
    />
  </div>
</template>
<script>
import SvgIcon from '../../SvgIcon.vue';
import SelectAdicionarCampos from './SelectAdicionarCampos.vue';
export default {
  props: {
    filtros: {
      type: Array,
      required: true
    },
    campos: {
      type: Array,
      required: true
    }
  },
  emits: ['renderizarFiltros'],
  data() {
    return {
      addFilterActive: false,
      filtrosSelecionados: []
    }
  },
  components: {
    SvgIcon,
    SelectAdicionarCampos
  },
  methods: {
    toogleSelectAddFiltro() {
      this.addFilterActive = !this.addFilterActive;
    },
    adicionarFiltro(campos) {
      if (!Array.isArray(campos)) {
        console.warn('O parâmetro campos deve ser um array');
        return;
      }

      this.$emit('renderizarFiltros', campos);
    },
  }
}
</script>
